// extracted by mini-css-extract-plugin
export default {"pin-key":"PinKey_pin-key__YQNw6"};